import React from 'react';
import Config from 'Config';
import LoadingPage from 'components/Pages/LoadingPage/LoadingPage.jsx';
/**
 * Redirects to external links are not supported by React router
 * @param {String} path
 */
export const auth0Redirect = (path) => {
  // for external redirects across apps
  const dev = process.env.NODE_ENV && process.env.NODE_ENV === 'development';
  let url = `${Config.svcFeed.root}${path}`;

  if (dev) {
    url = `${Config.svcFeed.root}${path}`;
  }
  window.location = url;
  // we have to return something for React to process
  return <LoadingPage />;
};
